/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import {
  APPLICATION_STATUS_ALIMONY,
  APPLICATION_STATUS_BASIC,
  APPLICATION_STATUS_CHILDREN,
  APPLICATION_STATUS_CONTACT,
  APPLICATION_STATUS_DOCUMENTS,
  APPLICATION_STATUS_MESSAGE,
  APPLICATION_STATUS_PARTNER,
  APPLICATION_STATUS_PETITIONER,
  APPLICATION_STATUS_SUMMARY,
} from "../applicationStatus";
import HintBox from "../../../components/Box/HintBox/HintBox";
import React from "react";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import progressBarsteps from "./progressBarSteps";
import alimonyFormSteps from "../formSteps";
import AlimonyPerson from "../../../components/Form/FamilyLaw/Alimony/AlimonyPerson";
import Alimony from "../../../components/Form/FamilyLaw/Alimony/Alimony";
import AlimonyChildren from "../../../components/Form/FamilyLaw/Alimony/AlimonyChildren";
import AlimonyChoice from "../../../components/Form/FamilyLaw/Alimony/AlimonyChoice";
import Documents from "../../../components/Form/Common/Documents/Documents";
import PersonalTextMessage from "../../../components/Form/Common/PersonalTextMessage/PersonalTextMessage";
import Personal from "../../../components/Form/Common/Personal/Personal";
import { FormSteps } from "../../../types/FormServiceBase";
import Summary from "../../../components/Form/FamilyLaw/Alimony/Summary";
import SummaryHintBox from "../../../components/Form/Common/SummaryHintBox";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_BASIC]: {
    ...alimonyFormSteps[APPLICATION_STATUS_BASIC],
    render: (props) => (
      <>
        <HintBox headline={"Ihre persönliche Unterhaltsberechnung"}>
          <p>
            Sie können auf den folgenden Seiten Angaben zu Ihrer Situation machen und den individuellen Kindes- und ggf. Ehegattenunterhalt berechnen lassen. Im
            Anschluss erhalten Sie eine detaillierte Berechnung sowie eine individuelle Analyse inklusive Link zur Terminvereinbarung eines Erstgesprächs mit
            einem Fachanwalt, damit Sie all Ihre Fragen in Ruhe besprechen können.
          </p>
        </HintBox>
        <ProgressBar steps={progressBarsteps} active={"base"} progress={8} />
        <AlimonyChoice {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_ALIMONY]: {
    ...alimonyFormSteps[APPLICATION_STATUS_ALIMONY],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"calculate"} progress={30} />
        <Alimony {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CHILDREN]: {
    ...alimonyFormSteps[APPLICATION_STATUS_CHILDREN],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"calculate"} progress={30} />
        <AlimonyChildren {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_PETITIONER]: {
    ...alimonyFormSteps[APPLICATION_STATUS_PETITIONER],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"calculate"} progress={30} />
        <AlimonyPerson {...props} personType={"alimonyPetitioner"} key={"alimonyPetitioner"} />
      </>
    ),
  },
  [APPLICATION_STATUS_PARTNER]: {
    ...alimonyFormSteps[APPLICATION_STATUS_PARTNER],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"calculate"} progress={40} />
        <AlimonyPerson {...props} personType={"alimonyPartner"} key={"alimonyPartner"} />
      </>
    ),
  },
  [APPLICATION_STATUS_MESSAGE]: {
    ...alimonyFormSteps[APPLICATION_STATUS_MESSAGE],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"question"} progress={50} />
        <PersonalTextMessage {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_DOCUMENTS]: {
    ...alimonyFormSteps[APPLICATION_STATUS_DOCUMENTS],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"documents"} progress={70} />
        <Documents {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CONTACT]: {
    ...alimonyFormSteps[APPLICATION_STATUS_CONTACT],
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={90} />
        <Personal {...props} personPath={"alimonyPetitioner.person"} />
      </>
    ),
  },
  [APPLICATION_STATUS_SUMMARY]: {
    ...alimonyFormSteps[APPLICATION_STATUS_SUMMARY],
    render: (props) => (
      <>
        <SummaryHintBox />
        <Summary {...props} withInsurance={false} />
      </>
    ),
  },
};

export default formSteps;
